// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d4b75927","453":"5b69012f","455":"5f5c5b61","977":"5a4c1910"}[chunkId] + ".chunk.js";
};